import "./PricingCompare.css";

const featureRows = [
	{
		label: "Monthly price",
		render: (plan, yearly) => (
			<span className="pricing-compare-price">
				${(yearly ? plan.yearly : plan.monthly).toFixed(2)}
				<span style={{ fontSize: 12, fontWeight: 400, opacity: 0.6 }}>
					/{yearly ? "yr" : "mo"}
				</span>
			</span>
		),
	},
	{
		label: "Simultaneous devices",
		render: (plan) => plan.devices,
	},
	{
		label: "Streaming hours / month",
		render: (plan) =>
			plan.streamingHours ? `${plan.streamingHours} hrs` : "Unlimited",
	},
	{
		label: "Collection access",
		render: (plan) => plan.collectionLabel,
	},
	{
		label: "Playlist playback",
		render: (plan) =>
			plan.playlist ? (
				<span className="pricing-compare-check">✓</span>
			) : (
				<span className="pricing-compare-cross">✗</span>
			),
	},
	{
		label: "Commercial use",
		render: (plan) =>
			plan.commercial ? (
				<span className="pricing-compare-check">✓</span>
			) : (
				<span className="pricing-compare-cross">✗</span>
			),
	},
];

const colClass = (isSelected, isDisabled) =>
	[isSelected ? "is-selected-col" : "", isDisabled ? "is-disabled-col" : ""]
		.filter(Boolean)
		.join(" ");

const PricingCompare = ({ plans, selectedPlanKey, yearlyBilling }) => {
	return (
		<div className="pricing-compare">
			<h2 className="pricing-compare-title">Compare plans</h2>
			<p className="pricing-compare-subtitle">
				See what each plan includes side by side
			</p>
			<div className="pricing-compare-wrap">
				<table className="pricing-compare-table">
					<thead>
						<tr>
							<th>Feature</th>
							{plans.map((plan) => (
								<th
									key={plan.id}
									className={colClass(
										plan.key === selectedPlanKey,
										plan.disabled,
									)}
									style={{ "--col-color": plan.color }}
								>
									{plan.title}
									{plan.disabled && (
										<span className="pricing-compare-soon">Soon</span>
									)}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{featureRows.map((row) => (
							<tr key={row.label}>
								<td>{row.label}</td>
								{plans.map((plan) => (
									<td
										key={plan.id}
										className={colClass(
											plan.key === selectedPlanKey,
											plan.disabled,
										)}
									>
										{row.render(plan, yearlyBilling)}
									</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default PricingCompare;
